import { SearchIcon, TextInput } from "@codat/orchard-ui";
import { useState } from "react";

import { sendAmplitudeEvent } from "../../amplitude";
import { CompanyStatusType } from "../../utilsCompanyStatus";
import { ConnectionStatusType } from "../../utilsConnectorStatus";
import { opsSettings } from "../../App";
import styles from "./SearchBox.module.css";

interface SearchBoxProps {
  setSearch(term: opsSettings): void;
  setSyncStatusFilter: (status: CompanyStatusType) => void;
  setConnectorStatusFilter: (status: ConnectionStatusType) => void;
  isLoading: boolean;
}

export function SearchBox({
  setSearch,
  setSyncStatusFilter,
  setConnectorStatusFilter,
  isLoading,
}: Readonly<SearchBoxProps>) {
  const [tempSearch, setTempSearch] = useState<string>("");

  const keyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setSearch({
        page: 1,
        sort: "asc",
        sortBy: "company",
        search: tempSearch,
        syncStatusFilter: "",
        companyStatusFilter: "",
      });
      setTempSearch("");
      setSyncStatusFilter("" as CompanyStatusType);
      setConnectorStatusFilter("" as ConnectionStatusType);
      sendAmplitudeEvent({
        element: "Search Box",
        action: "Search for Company",
      });
    }
  };

  return (
    <div className={styles.searchBoxContainer}>
      <TextInput
        id="search-input"
        label="Search"
        showLabel={false}
        placeholder="Company name/Connector ID"
        iconLeft={{ icon: !isLoading && <SearchIcon /> }}
        isSkeleton={isLoading}
        variant="small"
        value={tempSearch}
        onKeyUp={keyUp}
        className={styles.input}
        onChange={(e) => setTempSearch(e.target.value)}
      />
    </div>
  );
}
